import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { KpiGrid, StatusChip } from "@/components/kcc/Kpi";
import { Panel, ModuleHeader } from "@/components/kcc/Panel";
import { DataTable, statusToChip } from "@/components/kcc/DataTable";

export default function Procurement360() {
    const [data, setData] = useState(null);
    useEffect(() => { api.get("/procurement/overview").then(({ data }) => setData(data)); }, []);
    return (
        <div className="space-y-6">
            <ModuleHeader kicker="Procurement360" title="Sourcing, Contracts & Spend" description="Requisitions, RFIs, tenders, purchase orders, supplier due-diligence, spend analytics and maverick-spend detection." />
            <KpiGrid kpis={data?.kpis || []} accent="cobalt" cols={4} />
            <Panel title="Purchase Order Register" accent="cobalt">
                <DataTable
                    columns={[
                        { key: "po_no", label: "PO #" },
                        { key: "supplier", label: "Supplier" },
                        { key: "description", label: "Description" },
                        { key: "value_usd", label: "Value", render: (r) => `$${r.value_usd.toLocaleString()}` },
                        { key: "created", label: "Created", render: (r) => r.created.slice(0, 10) },
                        { key: "requestor", label: "Requestor" },
                        { key: "status", label: "Status", render: (r) => <StatusChip status={statusToChip(r.status)}>{r.status}</StatusChip> },
                    ]}
                    rows={data?.purchase_orders || []}
                    testid="po-table"
                />
            </Panel>
        </div>
    );
}
